import { useQuery } from '@tanstack/react-query';

import { SKIM_TARGET, skimmerEndpoints } from '@d3/contract';

import { api } from '@shared/api';

import type { PortfolioSearchItem } from '../model/portfolio-search';
import { portfolioKeys } from './portfolio.keys';
import { toPortfolioSearchItem } from './portfolio-search.mapper';

/**
 * 헤더 검색(skimmer). keyword = 검색어, within = 회사명(헤더의 "검색어/회사명" 뒷부분 — 나누기는 화면이 한다).
 * 결과는 서버가 포트폴리오별로 묶어 준다.
 */
export function usePortfolioSearchQuery(
  search: { keyword: string; within?: string },
  options: { enabled: boolean },
) {
  return useQuery({
    queryKey: portfolioKeys.scope('search', search),
    queryFn: ({ signal }) =>
      api.request(skimmerEndpoints.skim, {
        params: { target: SKIM_TARGET.PORTFOLIO },
        query: { keyword: search.keyword, ...(search.within ? { within: search.within } : {}) },
        signal,
      }),
    select: (data): PortfolioSearchItem[] => data.items.map(toPortfolioSearchItem),
    enabled: options.enabled,
    staleTime: 60_000,
  });
}
